import { columns } from "../../../../dtos/columns";
import Conversiones from "../../../../utils/conversiones";
import { EnumTipoEstadoRegistro, EstadoRegistro } from "../../../../utils/enums";
import AccionesTasas from "../components/accionesTasas";
import { Tasa, TasaEditar } from "../models/tasa";


interface IProps {
    controlTabla: any;
    setTasasEditar: React.Dispatch<React.SetStateAction<TasaEditar | undefined>>;
    setModalDetalle: React.Dispatch<React.SetStateAction<boolean>>;
}

export function useColumns({ controlTabla, setTasasEditar, setModalDetalle }: IProps) {

    const COLUMNS: columns<Tasa>[] = [
        {
            name: 'Acciones',
            selector: (row) => '',
            cell: (row) =>
                <AccionesTasas
                    tasa={row}
                    control={controlTabla}
                    setTasasEditar={setTasasEditar}
                    setModalDetalle={setModalDetalle}
                />,
            allowOverflow: true,
            button: true,
            export: false,
            alling: 'center'
        },
        {
            name: 'Tasa',
            selector: (row) =>
                row.valor,
            sortable: true,
            sortField: 'valor',
            wrap: true,
            export: true
        },
        {
            name: 'Fecha Inicio',
            selector: (row) => Conversiones.fechaCortaFormat(row.fechaInicioVigencia.toString()),
            sortable: true,
            sortField: 'fechaInicioVigencia',
            wrap: true,
            export: true,
            alling: 'left'

        },
        {
            name: 'Fecha Término',
            selector: (row) =>
                Conversiones.fechaCortaFormat(row.fechaTerminoVigencia.toString()),
            sortable: true,
            sortField: 'fechaTerminoVigencia',
            wrap: true,
            export: true,
            alling: 'left'

        },
        {
            name: 'Monto Desde',
            selector: (row) =>
                row.montoDesde,
            sortable: true,
            sortField: 'montoDesde',
            wrap: true,
            export: true,
        },
        {
            name: 'Monto Hasta',
            selector: (row) =>
                row.montoHasta,
            sortable: true,
            sortField: 'montoHasta',
            wrap: true,
            export: true,
        },
        {
            name: 'Estado',
            selector: (row) =>
                row.activo,
            sortable: true,
            sortField: 'activo',
            wrap: true,
            export: true,
        },
    ]


    return { COLUMNS };
}